module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-center items-center columnMain"
  }, _vm._l((_vm.config['column']), function(item, index) {
    return _c('div', {
      staticClass: "column column-lv1 relative",
      attrs: {
        "index": index
      }
    }, _vm._l((item), function(value, key) {
      return (key !== 'href') ? _c('div', {
        class: 'column-' + key
      }, [_c('span', [_vm._v(_vm._s(value))])]) : _vm._e()
    }), 0)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ac8b2a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/column/column.vue
// module id = 277
// module chunks = 1